import { render, staticRenderFns } from "./SetLSDGrid.vue?vue&type=template&id=3953b97e"
import script from "./SetLSDGrid.vue?vue&type=script&lang=ts"
export * from "./SetLSDGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports